import { Link as ScrollLink } from 'react-scroll';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import logo from '../moodmealslogo.png';
import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";
import back from "../assets/icons/back-arrow.png"
import user1 from "../assets/icons/User.png";

import '../styles/OrdersPage.css';

const OrdersPage=({user,onLogout,logoutSuccess,setLogoutSuccess})=>{

  const [orders,setOrders]=useState([]);
  const [isLoading,setIsLoading]=useState(true);
  const [isDropdownOpen,setIsDropdownOpen]=useState(false);
  const navigate=useNavigate();
  const dropdownRef=useRef(null);

  useEffect(()=>{
    setTimeout(()=>{
      setIsLoading(false);
    },2000);
  },[]);
  
  useEffect(()=>{
    if(logoutSuccess){
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setLogoutSuccess(false);
            navigate('/');
        }, 2000);
    }
  },[logoutSuccess,navigate,setLogoutSuccess]);

  useEffect(()=>{
    axios.get(`/api/user/getOrders`,{withCredentials:true})
    .then(res=>{
        console.log(res.data.order);
        setOrders(res.data.order);
    })
    .catch(err=>{
        console.error('No active session:',err);
    })
  },[]);

  const toggleUser=()=>{
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside=(e)=>{
      if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
          setIsDropdownOpen(false);
      }
  };

  useEffect(()=>{
      document.addEventListener('mousedown',handleClickOutside);
      return()=>{
          document.removeEventListener('mousedown',handleClickOutside);
      };
  },[]);

  return (
    <>
      {isLoading?(
        <div className="loadingContainer">
            <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
        </div>
      ):(
      <>
        {/* <!-- Order Section --> */}
        <main className="order-bg-wrapper">
          {/* <!-- Header Section --> */}
          <header className="order-header">
            <div className="order-back">
              <Link to="/"><img src={back} className="order-back-btn" alt="Back"/> Back</Link>
            </div>
            <div className="user-profile">
              <div className="user-bg">
                <h5>{user.firstname} {user.lastname}</h5>
              </div>
              <div className="orderDropdown">
                <img src={user?user.avatar:user1} alt="#User Avatar" loading="lazy" onClick={toggleUser}/>
                {isDropdownOpen&&(
                    <div className="order-dropdownMenu" ref={dropdownRef}>
                        {user?(
                            <>
                              <p className="order-dropdownItem">Welcome, {user.firstname}</p>
                              <Link to="/profile" className="order-dropdownItem">Profile</Link>
                              <Link to="/setting" className="order-dropdownItem">Setting</Link>
                              <Link onClick={onLogout} className="order-dropdownItem">Log Out</Link>
                            </>
                        ):(
                            <>
                              <Link to="/login" className="order-dropdownItem">Login</Link>
                              <Link to="/register" className="order-dropdownItem">Register</Link>
                            </>
                        )}
                    </div>
                )}
              </div>
            </div>
          </header>
          <main className="order-main">
            <section className="your-order">
                <h1>Your Orders</h1>
                <div className="order-list">
                    {orders.length?(
                       orders.map((element,index)=>(
                            <div className="order-items" key={index}>
                                <div className="order-content">
                                    <p>Total: {element.order_total}</p>
                                    <p>Subtotal: {element.order_subtotal}</p>
                                    <p>Shipping Fee: {element.order_sf}</p>
                                    <p>Dicounts: {element.order_discounts}</p>
                                    <p>Promo Code: {element.order_promocode}</p>
                                    <p>Tax: {element.order_tax}</p>
                                    <p>Payment Method: {element.order_method}</p>
                                    {element.cart&&element.cart.length?(
                                        element.cart.map((element,index)=>(
                                            <div className="order-items" key={index}>
                                                <div className="order-content">
                                                    <img src={element.cart_img} alt={`Cart ${index}`} />
                                                    <h3>Name: {element.cart_name}</h3>
                                                    <p>Box Size: {element.cart_boxsize}</p>
                                                    <p>Diet Preference: {element.cart_dietpref}</p>
                                                    <p>Quantity: {element.cart_qty}</p>
                                                    <p>Price: {element.cart_itemprice}</p>
                                                </div>
                                            </div>
                                        ))
                                    ):(
                                        <p>No items in cart</p>
                                    )}
                                </div>
                            </div>
                        ))
                    ):(
                        <h3>No Orders Found</h3>
                    )}
                </div>
            </section>
          </main>
        </main>
        {/* <!-- Footer Section --> */}
        <footer className="order-footer">
          <h3 className="order-get-in-touch">Get in Touch</h3>
          <div className="order-footer-content">
              <div className="order-footer-section">
                <h3>Customer Support</h3>
                <p>Email: <a href="/">support@moodmeals.com</a></p>
                <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                <h3>General Inquiries:</h3>
                <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                <h3>Partnership Opportunities:</h3>
                <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
              </div>
              <div className="order-footer-section">
                <h3>Quick Links</h3>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/shop">Shop</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                  <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                  <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                </ul>
              </div>
              <div className="order-footer-section">
                <h3>Customer Services</h3>
                <ul>
                  <li><a href="#contact-us">Contact Us</a></li>
                  <li><a href="#faq">FAQ</a></li>
                  <li><a href="#shipping&returns">Shipping & Returns</a></li>
                  <li><a href="#terms&condition">Terms & Condition</a></li>
                  <li><a href="#privacy">Privacy Policy</a></li>
                </ul>
              </div>
          </div>
          <div className="order-soc-med">
            <div className="order-app-wrapper">
              <img className="app" src={facebook} alt="facebook"/>
              <img className="app" src={instagram} alt="instagram"/>
              <img className="app" src={twitter} alt="twitter"/>
              <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
            </div>
            <div className="order-copyright">
                <p>&copy; 2024 MoodMeals. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </>
      )}
    </>
  )
}

export default OrdersPage;